<template>
  <div class="widget-container">
    <div class="d-flex row pt-2">
      <div class="d-flex col-6">
        <!-- График -->
        <div class="chart-container">
          <svg
            class="progress-svg"
            width="150"
            height="150"
            viewBox="0 0 36 36"
          >
            <!-- Дуга Sleep -->
            <circle
              class="progress-circle sleep"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${vascularRiskPercent}, 100`"
            ></circle>
            <circle
              class="progress-circle sleep2"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${(vascularRiskPercent * 30) / 100}, 100`"
            ></circle>
            <!-- Дуга Read -->
            <circle
              class="progress-circle read"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${riskFactorsPercent}, 100`"
            ></circle>
            <circle
              class="progress-circle read2"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${(riskFactorsPercent * 30) / 100}, 100`"
            ></circle>
            <!-- Дуга Exercise -->
            <circle
              class="progress-circle exercise"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${lipidMetabolismPercent}, 100`"
            ></circle>
            <circle
              class="progress-circle exercise2"
              cx="18"
              cy="18"
              r="15.91549431"
              :stroke-dasharray="`${lipidMetabolismPercent * 0.3}, 100`"
            ></circle>
          </svg>
          <!-- Центральный текст -->
          <div class="inner-circle">
            <span class="progress-text">{{ totalProgress }}</span>
          </div>
        </div>
      </div>
      <!-- Легенда -->
      <div class="d-flex col-6 ms-2">
        <ul class="widget-legend">
          <li><span class="legend-dot sleep"></span> Сосудистый риск</li>
          <li><span class="legend-dot read"></span> Факторы риска</li>
          <li><span class="legend-dot exercise"></span> Липидный обмен</li>
        </ul>
      </div>
    </div>
    <div
      class="ps-2 pe-2 pe-0 py-2 mt-4 blocktext"
      :style="'border-left: 10px solid ' + warningColor"
    >
      {{ warningMessage }}
      <div class="health-index-container">
        <div class="health-index-label">
          Health Index: {{ 100 - Math.round((healthIndex / 140) * 100) }}/100
        </div>
        <div class="health-index-progress">
          <div
            class="health-index-bar"
            :style="{
              width: 100 - Math.round((healthIndex / 140) * 100) + '%',
              backgroundColor: warningColor,
            }"
          ></div>
        </div>
        <!--         <div class="health-index-details">
          <div class="health-index-factor">
            <span class="factor-name">Сердечно-сосудистый риск:</span>
            <span class="factor-value">{{ heartRiskScore }}</span>
          </div>
          <div class="health-index-factor">
            <span class="factor-name">Артериальная гипертензия:</span>
            <span class="factor-value">{{ hypertensionScore }}</span>
          </div>
          <div class="health-index-factor">
            <span class="factor-name">Нарушения липидного обмена:</span>
            <span class="factor-value">{{ lipidScore }}</span>
          </div>
          <div class="health-index-factor">
            <span class="factor-name">Наследственность:</span>
            <span class="factor-value">{{ geneticScore }}</span>
          </div>
          <div class="health-index-factor">
            <span class="factor-name">Курение:</span>
            <span class="factor-value">{{ smokingScore }}</span>
          </div>
        </div> -->
      </div>
    </div>
    <div class="contaccordion">
      <Accordion
        value="null"
        :activeIndex="activeAccordion"
        @tab-open="handleTabOpen"
      >
        <AccordionPanel v-for="tab in tabs" :key="tab.title" :value="tab.value">
          <AccordionHeader :style="'color:' + tab.color">{{
            tab.title
          }}</AccordionHeader>
          <AccordionContent>
            <!-- Специальное отображение для липидного профиля -->
            <div v-if="tab.value === '2' && tab.lipidData">
              <div class="lipid-profile-container">
                <div class="lipid-parameter-row">
                  <div class="lipid-parameter-name">ЛПНП</div>
                  <div class="lipid-parameter-value">
                    {{
                      tab.lipidData.lpnp.value
                        ? tab.lipidData.lpnp.value.toFixed(1)
                        : "Нет данных"
                    }}
                  </div>
                  <div
                    class="lipid-parameter-status"
                    :class="{
                      'status-high': tab.lipidData.lpnp.risk === 'high',
                      'status-normal': tab.lipidData.lpnp.risk === 'low',
                      'status-unknown': tab.lipidData.lpnp.risk === 'unknown',
                    }"
                  >
                    {{
                      tab.lipidData.lpnp.risk === "high"
                        ? "Высокий"
                        : tab.lipidData.lpnp.risk === "low"
                        ? "Не повышен"
                        : "Нет данных"
                    }}
                  </div>
                </div>

                <div class="lipid-parameter-row">
                  <div class="lipid-parameter-name">ЛПВП</div>
                  <div class="lipid-parameter-value">
                    {{
                      tab.lipidData.lpvp.value
                        ? tab.lipidData.lpvp.value.toFixed(1)
                        : "Нет данных"
                    }}
                  </div>
                  <div
                    class="lipid-parameter-status"
                    :class="{
                      'status-low': tab.lipidData.lpvp.risk === 'low',
                      'status-normal': tab.lipidData.lpvp.risk === 'normal',
                      'status-unknown': tab.lipidData.lpvp.risk === 'unknown',
                    }"
                  >
                    {{
                      tab.lipidData.lpvp.risk === "low"
                        ? "Снижен"
                        : tab.lipidData.lpvp.risk === "normal"
                        ? "Не снижен"
                        : "Нет данных"
                    }}
                  </div>
                </div>

                <div class="lipid-parameter-row">
                  <div class="lipid-parameter-name">Триглицериды</div>
                  <div class="lipid-parameter-value">
                    {{
                      tab.lipidData.tg.value
                        ? tab.lipidData.tg.value.toFixed(1)
                        : "Нет данных"
                    }}
                  </div>
                  <div
                    class="lipid-parameter-status"
                    :class="{
                      'status-high': tab.lipidData.tg.risk === 'high',
                      'status-normal': tab.lipidData.tg.risk === 'low',
                      'status-unknown': tab.lipidData.tg.risk === 'unknown',
                    }"
                  >
                    {{
                      tab.lipidData.tg.risk === "high"
                        ? "Высокий"
                        : tab.lipidData.tg.risk === "low"
                        ? "Не повышен"
                        : "Нет данных"
                    }}
                  </div>
                </div>

                <div class="lipid-description mt-3">
                  {{ tab.content }}
                </div>
              </div>
            </div>
            <p v-else class="m-0">
              {{ tab.content }}
            </p>
          </AccordionContent>
        </AccordionPanel>
      </Accordion>
    </div>
    <div class="d-grid py-3 py-md-5" style="width: 100%">
      <Button
        label="Пройти опрос заново"
        severity="primary"
        style="background-color: #4baf50"
        rounded
        raised
        @click="resetAndNavigate"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted } from "vue";
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import { useRouter } from "vue-router";
import { fetchLatestRiskInfo, fetchLatestLipidsData } from "@/services/api";
import { loadFromLocalDB } from "@/services/dataService";
import { assessLipidProfile } from "@/utils/riskCalculator";

// Определяем интерфейсы для типизации данных
interface LipidDataItem {
  value?: number;
  risk: string;
}

interface LipidData {
  lpnp: LipidDataItem;
  lpvp: LipidDataItem;
  tg: LipidDataItem;
}

interface TabItem {
  title: string;
  content: string;
  color: string;
  value: string;
  type?: string;
  lipidData?: LipidData | null;
}

export default defineComponent({
  setup() {
    const router = useRouter();
    const totalProgress = ref("СРЕДНИЙ");
    const warningMessage = ref(
      "Выраженные нарушения липидного обмена и артериальная гипертензия указывают на высокий сердечно-сосудистый риск. Необходимо обратиться к врачу-липидологу или кардиологу для корректировки терапии."
    );
    const warningColor = ref("#ff3b30"); // Красный цвет по умолчанию
    const activeAccordion = ref(null);
    const currentHeartRiskLevel = ref("medium");

    // Добавляем переменные для хранения баллов по каждому фактору
    const heartRiskScore = ref(0);
    const hypertensionScore = ref(0);
    const lipidScore = ref(0);
    const geneticScore = ref(0);
    const smokingScore = ref(0);
    const healthIndex = ref(0);

    // Добавляем переменные для процентов заполнения дуг
    const vascularRiskPercent = ref(0);
    const riskFactorsPercent = ref(0);
    const lipidMetabolismPercent = ref(0);

    const tabs = ref<TabItem[]>([
      {
        title: "Низкий сердечно-сосудистый риск",
        content:
          "Ваш сердечно-сосудистый риск на ближайшие 10 лет оценивается как низкий. Однако помните, что здоровье сердца зависит от многих факторов, поэтому важно продолжать заботиться о своем здоровье. Поддерживайте здоровый образ жизни и регулярно проходите профилактические осмотры.",
        color: "#4baf50",
        type: "risk",
        value: "0",
      },
      {
        title: "Артериальная гипертензия",
        content: "",
        color: "#fc4a25",
        value: "1",
      },
      {
        title: "Липидный профиль",
        content:
          "Ваш уровень общего холестерина в пределах референтных значений, что снижает риск сердечно-сосудистых осложненний, однако рекомендуется сдать кровь для оценки всех показателей липидограммы. Развернутый анализ липидного профиля является одним из важнейших этапов в оценке индивидуального сердечно-сосудистого риска. Регулярный контроль уровня холестерина и его фракций позволяет эффективно управлять риском развития сердечно-сосудистых заболеваний, своевременно начинать и корректировать терапию, а также оценивать эффективность мероприятий по модификации образа жизни.",
        value: "2",
        color: "#757575",
        lipidData: null,
      },
      {
        title: "Наследственность",
        content:
          "Вероятность наличия семейной формы гиперхолестеринемии низкая. Однако, это не полностью исключает риск развития атеросклероза и сердечно-сосудистых осложнений. Важно регулярно проходить профилактические осмотры и вести здоровый образ жизни.",
        color: "#4baf50",
        value: "3",
      },
      {
        title: "Курение",
        content: "",
        color: "#4baf50",
        value: "4",
      },
    ]);

    // Функция для обновления данных липидного профиля
    const updateLipidProfile = async () => {
      try {
        console.log("Обновление данных липидного профиля...");

        // Получаем последние данные липидного профиля
        const lipidData = await fetchLatestLipidsData();

        if (lipidData) {
          console.log("Получены данные липидного профиля:", lipidData);

          // Получаем вкладку липидного профиля
          const lipidTab = tabs.value.find((tab) => tab.value === "2");

          if (lipidTab) {
            // Оцениваем липидный профиль на основе полученных данных
            const assessment = assessLipidProfile(
              lipidData.ldl,
              lipidData.hdl,
              lipidData.tg,
              localStorage.getItem("user_gender") || undefined,
              currentHeartRiskLevel.value
            );

            // Формируем объект с данными для отображения
            const newLipidData: LipidData = {
              lpnp: {
                value: lipidData.ldl,
                risk:
                  assessment.lpnp_risk === 0
                    ? "unknown"
                    : assessment.lpnp_risk === 1
                    ? "low"
                    : "high",
              },
              lpvp: {
                value: lipidData.hdl,
                risk:
                  assessment.lpvp_risk === 0
                    ? "unknown"
                    : assessment.lpvp_risk === 1
                    ? "normal"
                    : "low",
              },
              tg: {
                value: lipidData.tg,
                risk:
                  assessment.tg_risk === 0
                    ? "unknown"
                    : assessment.tg_risk === 1
                    ? "low"
                    : "high",
              },
            };

            // Обновляем данные липидного профиля
            lipidTab.lipidData = newLipidData;

            // Обновляем заголовок и содержимое вкладки
            if (assessment.overall_risk === "low") {
              lipidTab.title = "Нормальный липидный профиль";
              lipidTab.color = "#4baf50"; // Зеленый
              lipidScore.value = 0; // Нет нарушений
            } else if (
              assessment.overall_risk === "medium" ||
              assessment.overall_risk === "high"
            ) {
              lipidTab.title =
                assessment.overall_risk === "medium"
                  ? "Умеренные нарушения липидного обмена"
                  : "Нарушения липидного обмена";
              lipidTab.color =
                assessment.overall_risk === "medium" ? "#f59e21" : "#fc4a25";
              lipidScore.value = 20; // Есть нарушения
            } else {
              lipidTab.title = "Липидный профиль";
              lipidTab.color = "#757575"; // Серый
              lipidScore.value = 0; // По умолчанию нет нарушений
            }

            // Обновляем описание
            lipidTab.content = assessment.description;

            console.log("Данные липидного профиля обновлены:", lipidTab);

            // Пересчитываем Health Index после обновления данных о липидном профиле
            calculateHealthIndex();
          }
        } else {
          console.log("Данные липидного профиля не получены");
        }
      } catch (error) {
        console.error("Ошибка при обновлении данных липидного профиля:", error);
      }
    };

    // Обработчик открытия вкладки аккордеона
    const handleTabOpen = (e: any) => {
      activeAccordion.value = e.index;

      // Если открыта вкладка липидного профиля, обновляем данные
      if (tabs.value[e.index].value === "2") {
        updateLipidProfile();
      }
    };

    // Функция для расчета процентов заполнения дуг
    const calculateChartPercentages = () => {
      console.log("Расчет процентов заполнения дуг...");

      // Сосудистый риск (факторы, влияющие напрямую на сосуды)
      // Максимум: 40 + 30 + 20 + 30 = 120
      const vascularRiskScore =
        heartRiskScore.value +
        hypertensionScore.value +
        lipidScore.value +
        smokingScore.value;
      vascularRiskPercent.value = Math.min(
        Math.round((vascularRiskScore / 120) * 100),
        100
      );

      // Факторы риска (общие предрасполагающие факторы)
      // Максимум: 40 + 30 + 20 + 30 = 120
      const riskFactorsScore =
        heartRiskScore.value +
        hypertensionScore.value +
        geneticScore.value +
        smokingScore.value;
      riskFactorsPercent.value = Math.min(
        Math.round((riskFactorsScore / 120) * 100),
        100
      );

      // Липидный обмен (факторы, влияющие на холестерин и жировой обмен)
      // Максимум: 20 + 20 = 40
      const lipidMetabolismScore = lipidScore.value + geneticScore.value;
      lipidMetabolismPercent.value = Math.min(
        Math.round((lipidMetabolismScore / 40) * 100),
        100
      );

      console.log(`Сосудистый риск: ${vascularRiskPercent.value}%`);
      console.log(`Факторы риска: ${riskFactorsPercent.value}%`);
      console.log(`Липидный обмен: ${lipidMetabolismPercent.value}%`);
    };

    // Функция для генерации персонализированного заключения
    const generateConclusion = () => {
      console.log("Генерация персонализированного заключения...");

      // Определяем уровни факторов риска
      const heartRiskLevel = currentHeartRiskLevel.value; // low, medium, high

      // Определяем уровень артериальной гипертензии
      let hypertensionLevel = "none"; // none, normal-high, hypertension
      if (hypertensionScore.value === 30) {
        hypertensionLevel = "hypertension";
      } else if (hypertensionScore.value === 10) {
        hypertensionLevel = "normal-high";
      }

      // Определяем наличие липидных нарушений
      const hasLipidDisorders = lipidScore.value > 0;

      // Определяем уровень наследственного риска
      let geneticLevel = "low"; // low, medium, high
      if (geneticScore.value === 20) {
        geneticLevel = "high";
      } else if (geneticScore.value === 10) {
        geneticLevel = "medium";
      }

      // Определяем наличие курения
      const isSmoking = smokingScore.value > 0;

      // Формируем заключение на основе комбинации факторов
      let conclusion = "";

      // 1. Низкий сердечно-сосудистый риск
      if (heartRiskLevel === "low") {
        // Без других факторов риска
        if (
          hypertensionLevel === "none" &&
          !hasLipidDisorders &&
          geneticLevel === "low" &&
          !isSmoking
        ) {
          conclusion =
            "Ваши показатели в норме, сердечно-сосудистый риск минимален. Рекомендуется вести здоровый образ жизни, контролировать питание и уровень физической активности.";
        }
        // При умеренно повышенном давлении или наличии наследственности
        else if (
          (hypertensionLevel === "normal-high" ||
            geneticLevel === "medium" ||
            geneticLevel === "high") &&
          !hasLipidDisorders &&
          !isSmoking
        ) {
          conclusion =
            "Несмотря на низкий общий риск, выявлены факторы риска, предрасполагающие к развитию сердечно-сосудистых заболеваний. Контроль артериального давления и липидного профиля поможет предотвратить развитие заболеваний.";
        }
        // При наличии липидных нарушений и/или курении
        else if (
          (hasLipidDisorders || isSmoking) &&
          hypertensionLevel === "none" &&
          geneticLevel === "low"
        ) {
          conclusion =
            "Несмотря на низкий сердечно-сосудистый риск, выявлены " +
            (hasLipidDisorders && isSmoking
              ? "отклонения липидного обмена и фактор курения"
              : hasLipidDisorders
              ? "отклонения липидного обмена"
              : "фактор курения") +
            ", что требует консультации врача для коррекции факторов риска.";
        }
        // При сочетании нескольких факторов
        else {
          conclusion =
            "Несмотря на низкий общий риск, " +
            (hasLipidDisorders
              ? "выраженные изменения липидного профиля, "
              : "") +
            (hypertensionLevel === "hypertension"
              ? "артериальная гипертензия "
              : "") +
            (geneticLevel === "high"
              ? "и высокая вероятность наследственно обусловленной гиперхолестеринемии "
              : "") +
            "требуют незамедлительного обращения к " +
            (hasLipidDisorders ? "врачу-липидологу." : "врачу.");
        }
      }
      // 2. Средний сердечно-сосудистый риск
      else if (heartRiskLevel === "medium") {
        // Без других факторов риска
        if (
          hypertensionLevel === "none" &&
          !hasLipidDisorders &&
          geneticLevel === "low" &&
          !isSmoking
        ) {
          conclusion =
            "Умеренный сердечно-сосудистый риск требует наблюдения. Рекомендуется оценка липидного профиля, контроль артериального давления и соблюдение принципов здорового образа жизни.";
        }
        // При наличии АГ или ЛН
        else if (
          (hypertensionLevel !== "none" || hasLipidDisorders) &&
          !isSmoking
        ) {
          conclusion =
            "Средний риск в сочетании с " +
            (hypertensionLevel !== "none" ? "повышенным давлением" : "") +
            (hypertensionLevel !== "none" && hasLipidDisorders ? "/" : "") +
            (hasLipidDisorders ? "изменениями липидного обмена" : "") +
            " увеличивает вероятность сердечно-сосудистых осложнений. Необходимо контролировать давление и липиды, обсудить возможную терапию с врачом.";
        }
        // При наличии курения
        else if (
          isSmoking &&
          hypertensionLevel === "none" &&
          !hasLipidDisorders
        ) {
          conclusion =
            "Курение в сочетании со средним сердечно-сосудистым риском значительно повышает вероятность развития атеросклероза. Рекомендуется отказ от курения и профилактический осмотр у кардиолога.";
        }
        // При сочетании нескольких факторов
        else {
          conclusion =
            "Умеренный сердечно-сосудистый риск в сочетании с " +
            (hypertensionLevel === "hypertension" ? "гипертонией, " : "") +
            (hasLipidDisorders ? "нарушением липидного обмена " : "") +
            (geneticLevel !== "low" ? "и семейной предрасположенностью " : "") +
            "требует комплексного подхода к профилактике и лечению. Необходима консультация кардиолога и липидолога.";
        }
      }
      // 3. Высокий сердечно-сосудистый риск
      else {
        // Без других факторов риска
        if (
          hypertensionLevel === "none" &&
          !hasLipidDisorders &&
          geneticLevel === "low" &&
          !isSmoking
        ) {
          conclusion =
            "Высокий сердечно-сосудистый риск требует немедленной оценки состояния сосудов и коррекции образа жизни. Рекомендуется контроль липидов, артериального давления и консультация специалиста.";
        }
        // При наличии артериальной гипертензии или липидных нарушений
        else if (
          (hypertensionLevel !== "none" || hasLipidDisorders) &&
          !isSmoking
        ) {
          conclusion =
            "Высокий риск в сочетании с " +
            (hypertensionLevel !== "none" ? "гипертонией" : "") +
            (hypertensionLevel !== "none" && hasLipidDisorders ? " или " : "") +
            (hasLipidDisorders ? "изменениями липидного обмена" : "") +
            " значительно увеличивает вероятность инфаркта и инсульта. Требуется немедленное обследование и медикаментозная коррекция.";
        }
        // При наличии курения
        else if (
          isSmoking &&
          hypertensionLevel === "none" &&
          !hasLipidDisorders
        ) {
          conclusion =
            "Курение на фоне высокого сердечно-сосудистого риска многократно увеличивает вероятность сосудистых осложнений. Необходимо срочное прекращение курения и медицинское наблюдение.";
        }
        // При сочетании нескольких факторов
        else {
          conclusion =
            "Выраженные нарушения обмена липидов, артериальная гипертензия и высокий сердечно-сосудистый риск требуют немедленного медицинского вмешательства. Рекомендуется срочная консультация кардиолога, липидолога и комплексное обследование.";
        }
      }

      return conclusion;
    };

    // Функция для расчета Health Index
    const calculateHealthIndex = () => {
      console.log("Расчет Health Index...");
      console.log(
        `Сердечно-сосудистый риск: ${currentHeartRiskLevel.value} (${heartRiskScore.value})`
      );
      console.log(`Артериальная гипертензия: (${hypertensionScore.value})`);
      console.log(`Нарушения липидного обмена: (${lipidScore.value})`);
      console.log(`Наследственность: (${geneticScore.value})`);
      console.log(`Курение: (${smokingScore.value})`);

      // Суммируем баллы всех факторов
      let totalScore =
        heartRiskScore.value +
        hypertensionScore.value +
        lipidScore.value +
        geneticScore.value +
        smokingScore.value;

      // Ограничиваем максимальное значение до 100
      totalScore = Math.min(totalScore, 100);

      healthIndex.value = totalScore;
      console.log(`Health Index: ${healthIndex.value}`);

      // Определяем группу риска
      if (totalScore <= 30) {
        totalProgress.value = "НИЗКИЙ";
        warningColor.value = "#4baf50"; // Зеленый
      } else if (totalScore <= 60) {
        totalProgress.value = "СРЕДНИЙ";
        warningColor.value = "#f59e21"; // Оранжевый
      } else {
        totalProgress.value = "ВЫСОКИЙ";
        warningColor.value = "#fc4a25"; // Красный
      }

      // Генерируем персонализированное заключение
      warningMessage.value = generateConclusion();

      // Рассчитываем проценты заполнения дуг
      calculateChartPercentages();

      // Сохраняем данные в localStorage
      saveRiskDataToLocalStorage();

      return totalScore;
    };

    // Функция для сохранения данных о рисках в localStorage
    const saveRiskDataToLocalStorage = () => {
      console.log("Сохранение данных о рисках в localStorage...");

      const riskData = {
        heartRiskScore: heartRiskScore.value,
        heartRiskLevel: currentHeartRiskLevel.value,
        hypertensionScore: hypertensionScore.value,
        lipidScore: lipidScore.value,
        geneticScore: geneticScore.value,
        smokingScore: smokingScore.value,
        healthIndex: healthIndex.value,
        vascularRiskPercent: vascularRiskPercent.value,
        riskFactorsPercent: riskFactorsPercent.value,
        lipidMetabolismPercent: lipidMetabolismPercent.value,
        totalRiskLevel: totalProgress.value,
      };

      localStorage.setItem("health_risk_data", JSON.stringify(riskData));
      console.log("Данные о рисках сохранены в localStorage:", riskData);

      // Отправляем пользовательское событие для обновления виджета
      window.dispatchEvent(new Event("risk-data-updated"));
    };

    const loadRiskData = async () => {
      try {
        // Проверяем, есть ли сохраненные данные в localStorage
        const savedRiskData = localStorage.getItem("health_risk_data");
        let shouldRecalculate = true;

        if (savedRiskData) {
          console.log("Найдены сохраненные данные о рисках в localStorage");
          const parsedData = JSON.parse(savedRiskData);

          // Восстанавливаем значения из localStorage
          heartRiskScore.value = parsedData.heartRiskScore;
          currentHeartRiskLevel.value = parsedData.heartRiskLevel;
          hypertensionScore.value = parsedData.hypertensionScore;
          lipidScore.value = parsedData.lipidScore;
          geneticScore.value = parsedData.geneticScore;
          smokingScore.value = parsedData.smokingScore;
          healthIndex.value = parsedData.healthIndex;
          vascularRiskPercent.value = parsedData.vascularRiskPercent;
          riskFactorsPercent.value = parsedData.riskFactorsPercent;
          lipidMetabolismPercent.value = parsedData.lipidMetabolismPercent;
          totalProgress.value = parsedData.totalRiskLevel;

          // Устанавливаем цвет предупреждения в зависимости от уровня риска
          if (totalProgress.value === "НИЗКИЙ") {
            warningColor.value = "#4baf50"; // Зеленый
          } else if (totalProgress.value === "СРЕДНИЙ") {
            warningColor.value = "#f59e21"; // Оранжевый
          } else {
            warningColor.value = "#fc4a25"; // Красный
          }

          // Генерируем заключение на основе загруженных данных
          warningMessage.value = generateConclusion();

          // Если данные успешно загружены из localStorage, можно пропустить повторный расчет
          shouldRecalculate = false;
        }

        // Если нет сохраненных данных или нужно пересчитать, загружаем данные с сервера
        if (shouldRecalculate) {
          // Сначала пробуем загрузить из локальной БД
          let riskData = await loadFromLocalDB("latest_risk");

          // Если данных нет в локальной БД, загружаем с сервера
          if (!riskData) {
            riskData = await fetchLatestRiskInfo();
          }

          if (riskData) {
            // Обработка данных о курении
            if (riskData.smoke_risk) {
              const smokeRisk = JSON.parse(riskData.smoke_risk);
              // Обновляем вкладку с курением
              const smokingTab = tabs.value.find((tab) => tab.value === "4");
              if (smokingTab) {
                smokingTab.title = "Курение";
                smokingTab.content = smokeRisk.description;
                smokingTab.color =
                  smokeRisk.risk === "high" ? "#ff3b30" : "#4caf50";

                // Устанавливаем баллы за курение
                smokingScore.value = smokeRisk.risk === "high" ? 30 : 0;
              }
            }

            // Обработка данных о гипертензии
            if (riskData.hypertension_risk) {
              const hypertensionRisk = JSON.parse(riskData.hypertension_risk);
              // Обновляем вкладку с артериальной гипертензией
              const hypertensionTab = tabs.value.find(
                (tab) => tab.value === "1"
              );
              if (hypertensionTab) {
                hypertensionTab.title = "Артериальная гипертензия";
                hypertensionTab.content = hypertensionRisk.description;
                hypertensionTab.color =
                  hypertensionRisk.risk === "high"
                    ? "#ff3b30"
                    : hypertensionRisk.risk === "medium"
                    ? "#ffa14d"
                    : "#4caf50";

                // Устанавливаем баллы за гипертензию
                if (hypertensionRisk.risk === "high") {
                  hypertensionScore.value = 30; // Гипертония
                } else if (hypertensionRisk.risk === "medium") {
                  hypertensionScore.value = 10; // Нормально-повышенное
                } else {
                  hypertensionScore.value = 0; // Норма
                }
              }
            }

            // Обработка данных о генетическом риске
            if (riskData.genetic_risk) {
              const geneticRisk = JSON.parse(riskData.genetic_risk);
              // Обновляем вкладку с наследственностью
              const geneticTab = tabs.value.find((tab) => tab.value === "3");
              if (geneticTab) {
                geneticTab.title = "Наследственность";
                geneticTab.content = geneticRisk.description;
                geneticTab.color =
                  geneticRisk.risk === "high"
                    ? "#ff3b30"
                    : geneticRisk.risk === "medium"
                    ? "#ffa14d"
                    : "#4caf50";

                // Устанавливаем баллы за наследственность
                if (geneticRisk.risk === "high") {
                  geneticScore.value = 20; // Высокий риск
                } else if (geneticRisk.risk === "medium") {
                  geneticScore.value = 10; // Средний риск
                } else {
                  geneticScore.value = 0; // Низкий риск
                }
              }
            }

            // Обработка данных о сердечно-сосудистом риске
            if (riskData.heart_risk) {
              const heartRisk = JSON.parse(riskData.heart_risk);
              // Обновляем вкладку с сердечно-сосудистым риском
              const heartRiskTab = tabs.value.find((tab) => tab.value === "0");
              if (heartRiskTab) {
                // Формируем заголовок в зависимости от уровня риска
                let riskTitle = "Сердечно-сосудистый риск";
                if (heartRisk.risk === "low") {
                  riskTitle = "Низкий сердечно-сосудистый риск";
                  currentHeartRiskLevel.value = "low";
                  heartRiskScore.value = 0; // Низкий риск
                } else if (heartRisk.risk === "medium") {
                  riskTitle = "Умеренный сердечно-сосудистый риск";
                  currentHeartRiskLevel.value = "medium";
                  heartRiskScore.value = 20; // Средний риск
                } else if (heartRisk.risk === "high") {
                  riskTitle = "Высокий сердечно-сосудистый риск";
                  currentHeartRiskLevel.value = "high";
                  heartRiskScore.value = 40; // Высокий риск
                }

                heartRiskTab.title = riskTitle;

                // Если есть точное значение риска, добавляем его в описание
                let content = heartRisk.description;
                if (heartRisk.score) {
                  content += ` Ваш расчетный показатель риска: ${heartRisk.score}%.`;
                }

                heartRiskTab.content = content;
                heartRiskTab.color =
                  heartRisk.risk === "high"
                    ? "#fc4a25"
                    : heartRisk.risk === "medium"
                    ? "#f59e21"
                    : "#4baf50";
              }
            }

            // Обработка данных о липидном профиле
            if (riskData.lipid_risk) {
              try {
                // Пытаемся распарсить JSON строку
                const lipidRisk = JSON.parse(riskData.lipid_risk);

                // Обновляем вкладку с липидным профилем
                const lipidTab = tabs.value.find((tab) => tab.value === "2");
                if (lipidTab) {
                  // Устанавливаем заголовок в зависимости от уровня риска
                  if (lipidRisk.risk === "low") {
                    lipidTab.title = "Нормальный липидный профиль";
                    lipidTab.color = "#4baf50"; // Зеленый
                    lipidScore.value = 0; // Нет нарушений
                  } else if (
                    lipidRisk.risk === "medium" ||
                    lipidRisk.risk === "high"
                  ) {
                    lipidTab.title =
                      lipidRisk.risk === "medium"
                        ? "Умеренные нарушения липидного обмена"
                        : "Нарушения липидного обмена";
                    lipidTab.color =
                      lipidRisk.risk === "medium" ? "#f59e21" : "#fc4a25";
                    lipidScore.value = 20; // Есть нарушения
                  } else {
                    lipidTab.title = "Липидный профиль";
                    lipidTab.color = "#757575"; // Серый
                    lipidScore.value = 0; // По умолчанию нет нарушений
                  }

                  // Устанавливаем описание
                  lipidTab.content = lipidRisk.description;

                  // Сохраняем данные о показателях липидного профиля
                  if (lipidRisk.lpnp || lipidRisk.lpvp || lipidRisk.tg) {
                    const newLipidData: LipidData = {
                      lpnp: lipidRisk.lpnp || {
                        risk: "unknown",
                        value: undefined,
                      },
                      lpvp: lipidRisk.lpvp || {
                        risk: "unknown",
                        value: undefined,
                      },
                      tg: lipidRisk.tg || { risk: "unknown", value: undefined },
                    };
                    lipidTab.lipidData = newLipidData;
                  }
                }
              } catch (error) {
                console.error(
                  "Ошибка при парсинге данных о липидном профиле:",
                  error
                );

                // Если не удалось распарсить JSON, используем строку как есть
                const lipidTab = tabs.value.find((tab) => tab.value === "2");
                if (lipidTab) {
                  lipidTab.title = "Липидный профиль";
                  lipidTab.content = riskData.lipid_risk;
                }
              }
            }

            // Рассчитываем Health Index после загрузки всех данных
            calculateHealthIndex();
          }
        }

        // Обновляем данные липидного профиля после загрузки всех данных о рисках
        await updateLipidProfile();
      } catch (error) {
        console.error("Ошибка при загрузке данных о рисках:", error);
      }
    };

    // Функция для очистки данных и перехода на страницу onboarding
    const resetAndNavigate = () => {
      // Удаляем данные о рисках из localStorage
      localStorage.removeItem("health_risk_data");
      console.log("Данные о рисках удалены из localStorage");

      // Отправляем пользовательское событие для обновления виджета
      window.dispatchEvent(new Event("risk-data-updated"));

      // Переходим на страницу onboarding
      router.push("/onboarding");
    };

    onMounted(async () => {
      await loadRiskData();
    });

    return {
      totalProgress,
      tabs,
      warningMessage,
      warningColor,
      activeAccordion,
      handleTabOpen,
      healthIndex,
      heartRiskScore,
      hypertensionScore,
      lipidScore,
      geneticScore,
      smokingScore,
      vascularRiskPercent,
      riskFactorsPercent,
      lipidMetabolismPercent,
      resetAndNavigate,
    };
  },
  components: {
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
  },
});
</script>

<style scoped>
.row {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}
/* Основной контейнер виджета */
.widget-container {
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Заголовок */
.widget-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
  border-radius: 15px;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
}

.widget-header .pi-chart {
  margin-right: 8px;
  font-size: 16px;
}

/* SVG для дуг */
.chart-container {
  position: relative;
  width: 150px;
  height: 150px;
}

.progress-svg {
  position: relative;
  width: 150px;
  height: 150px;
  transform: rotate(-90deg); /* Исправление ориентации дуг */
}

.progress-circle {
  fill: none;
  stroke-width: 2.5;
  transform-origin: center;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.progress-circle.sleep {
  stroke: #fc4a2529;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  stroke-dasharray: 30 100;
  transform: rotate(-90deg);
}
.progress-circle.sleep2 {
  stroke: #fc4a25;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  /*   stroke-dasharray: 20 100; */
  transform: rotate(-90deg);
}

.progress-circle.read {
  stroke: #6fb0ff46;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  stroke-dasharray: 30 100;
  transform: rotate(390deg);
}
.progress-circle.read2 {
  stroke: #6fafff;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  /*   stroke-dasharray: 10 100; */
  transform: rotate(390deg);
}

.progress-circle.exercise {
  stroke: #f59e212e;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  stroke-dasharray: 30 100;
  transform: rotate(150deg);
}
.progress-circle.exercise2 {
  stroke: #f59e21;
  stroke-dashoffset: -30;
  stroke-linecap: round;
  stroke-miterlimit: 100;
  /*   stroke-dasharray: 20 100; */
  transform: rotate(150deg);
}

/* Центральный круг */
.inner-circle {
  position: absolute;
  width: 100px;
  height: 100px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.progress-text {
  font-size: 12pt;
  font-weight: 500;
  color: #333;
}

/* Легенда */
.widget-legend {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.legend-dot.sleep {
  background: #fc4a25;
}

.legend-dot.read {
  background: #6fafff;
}

.legend-dot.exercise {
  background: #f59e21;
}

/* Текст легенды */
.widget-legend li {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}
.contaccordion {
  margin-top: 20px;
  width: 100%;
  width: 100%;
  font-size: 11pt;
}

/* Стили для отображения липидного профиля */
.lipid-profile-container {
  width: 100%;
  padding: 0;
}

.lipid-profile-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.lipid-parameter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.lipid-parameter-name {
  font-weight: 500;
  flex: 1;
}

.lipid-parameter-value {
  flex: 1;
  text-align: center;
}

.lipid-parameter-status {
  flex: 1;
  text-align: right;
  padding: 2px 0px;
  border-radius: 15px;
  font-size: 10px;
  font-weight: 500;
  display: inline-block;
  min-width: 70px;
  text-align: center;
  max-width: 70px;
}

.status-high {
  background-color: #fc4a25;
  color: white;
}

.status-low {
  background-color: #fc4a25;
  color: white;
}

.status-normal {
  background-color: #4baf50;
  color: white;
}

.status-unknown {
  background-color: #757575;
  color: white;
}

.lipid-description {
  margin-top: 15px;
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}

.mt-3 {
  margin-top: 15px;
}

.health-index-container {
  margin-top: 15px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
}

.health-index-label {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
}

.health-index-progress {
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 12px;
}

.health-index-bar {
  height: 100%;
  transition: width 0.5s ease;
}

.health-index-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.health-index-factor {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.factor-name {
  color: #555;
}

.factor-value {
  font-weight: 600;
}
</style>
